module.exports = __webpack_public_path__ + "img/044d1cd.png";